import { render, staticRenderFns } from "./CommunitySettingsDelete.vue?vue&type=template&id=7e78d060&scoped=true&"
import script from "./CommunitySettingsDelete.vue?vue&type=script&lang=js&"
export * from "./CommunitySettingsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e78d060",
  null
  
)

export default component.exports